module.exports = __webpack_public_path__ + "static/media/IMG_20180608_155916.e7c57e15.jpg";